import { Link } from "react-router-dom";
import { categoryEmojis } from "../../utils/constants";

interface NextBestActionCardProps {
  action: any;
}

export default function NextBestActionCard({ action }: NextBestActionCardProps) {
  if (!action) {
    return (
      <div className="bg-surface-container-low border border-outline-variant/10 rounded-[2rem] p-6 h-full flex flex-col justify-center items-center text-center">
        <p className="text-lg font-bold text-on-surface mb-2">🎉 No pending actions right now.</p>
        <p className="text-sm text-on-surface-variant">Your next growth step will appear after you continue learning.</p>
      </div>
    );
  }

  const categoryName = action.business_impact_category?.name || 'General';
  const categoryEmoji = categoryEmojis[categoryName] || '📋';

  return (
    <div className="bg-surface-container-low border border-outline-variant/10 rounded-[2rem] p-6 h-full relative overflow-hidden group hover:border-primary/30 transition-colors">
      <div className="absolute top-0 right-0 w-32 h-32 bg-primary/5 rounded-full blur-[40px] -mr-10 -mt-10 pointer-events-none group-hover:bg-primary/10 transition-colors" />
      
      <div className="relative z-10">
        <div className="flex items-center justify-between mb-4">
          <p className="text-xs font-black uppercase tracking-widest text-primary flex items-center gap-2">
            🚀 Your Next Best Action
          </p>
          <Link 
            to={`/tasks`}
            className="text-[10px] font-bold text-on-surface-variant hover:text-primary transition-colors bg-surface-container-high px-2 py-1 rounded-md"
          >
            VIEW ALL
          </Link>
        </div>

        <h3 className="text-xl font-black text-on-surface mb-3 leading-tight group-hover:text-primary transition-colors">
          {action.title}
        </h3>

        <div className="flex flex-wrap items-center gap-3 mb-5">
          <span className="text-xs font-bold text-on-surface-variant flex items-center gap-1 bg-surface-container-high px-2 py-1 rounded-md">
            ⏱ {action.effort_minutes || 15} min
          </span>
          <span className="text-xs font-bold text-on-surface-variant flex items-center gap-1 bg-surface-container-high px-2 py-1 rounded-md">
            {categoryEmoji} {categoryName}
          </span>
          <span className="text-xs font-black text-green-600 dark:text-green-400 flex items-center gap-1 bg-green-500/10 px-2 py-1 rounded-md">
            +{action.points || 100} XP
          </span>
        </div>

        {action.coach_recommendation && (
          <div className="bg-primary/5 border border-primary/10 rounded-xl p-4">
            <p className="text-xs font-bold text-primary mb-2 flex items-center gap-2">
              👋 Joseph's Recommendation
            </p>
            <p className="text-sm text-on-surface-variant italic font-medium">
              "{action.coach_recommendation}"
            </p>
          </div>
        )}
        
        {!action.coach_recommendation && action.expected_outcome && (
          <div className="bg-primary/5 border border-primary/10 rounded-xl p-4">
            <p className="text-xs font-bold text-primary mb-2 flex items-center gap-2">
              🎯 Expected Outcome
            </p>
            <p className="text-sm text-on-surface-variant italic font-medium">
              "{action.expected_outcome}"
            </p>
          </div>
        )}

        <div className="mt-5">
          <Link 
            to={`/tasks/${action.id}`}
            className="inline-flex items-center gap-2 bg-primary text-on-primary px-4 py-2 rounded-xl text-sm font-bold shadow-md hover:bg-primary/90 hover:shadow-lg transition-all active:scale-95 w-full sm:w-auto justify-center"
          >
            ▶️ Start Now
          </Link>
        </div>
      </div>
    </div>
  );
}
